import { trackEvent } from "@/lib/audit";
import { awardPoints } from "@/lib/gamification";

export type MissionId =
  | "open_app"
  | "answer_trivia"
  | "view_stats"
  | "talk_to_ai"
  | "share_app";

export interface MissionDef {
  id: MissionId;
  i18nKey: string;
  reward: number;
}

export const DAILY_MISSIONS: MissionDef[] = [
  { id: "open_app",       i18nKey: "mission_open_app",       reward: 5 },
  { id: "answer_trivia",  i18nKey: "mission_answer_trivia",  reward: 15 },
  { id: "view_stats",     i18nKey: "mission_view_stats",     reward: 10 },
  { id: "talk_to_ai",     i18nKey: "mission_talk_to_ai",     reward: 10 },
  { id: "share_app",      i18nKey: "mission_share_app",      reward: 20 },
];

function todayKey() { return new Date().toISOString().slice(0, 10); }
const KEY = "ss2026_missions";

interface MissionState { date: string; completed: MissionId[]; }

function read(): MissionState {
  if (typeof window === "undefined") return { date: todayKey(), completed: [] };
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? "null") as MissionState | null;
    if (!raw || raw.date !== todayKey()) return { date: todayKey(), completed: [] };
    return raw;
  } catch { return { date: todayKey(), completed: [] }; }
}
function write(s: MissionState) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function listMissions() {
  const s = read();
  return DAILY_MISSIONS.map((m) => ({ ...m, completed: s.completed.includes(m.id) }));
}

export async function completeMission(id: MissionId): Promise<boolean> {
  const s = read();
  if (s.completed.includes(id)) return false;
  s.completed.push(id);
  write(s);
  const def = DAILY_MISSIONS.find((m) => m.id === id);
  if (def) {
    // Re-use gamification rules table when matching, else custom award.
    try { await awardPoints("prediction_vote", { mission: id, custom_reward: def.reward }); } catch { /* noop */ }
  }
  void trackEvent("mission_completed", { id, reward: def?.reward ?? 0 });
  return true;
}

export function missionProgress() {
  const s = read();
  return { done: s.completed.length, total: DAILY_MISSIONS.length };
}